/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import {
	LaborCountListFactory,
	PlanAccessListFactory,
	PlanListFactory,
	TicketExceptionDaysListFactory,
} from 'src/app/common/fancy-firebase/services/factories';
import { LaborCounts } from 'src/app/app-data/state/LaborCounts';
import { PlanAccessApi } from 'src/app/app-data/state/PlanAccessApi';
import { PlansApi } from 'src/app/app-data/state/PlansApi';
import { FancyIdJoin } from 'src/app/common/fancy-firebase/base/FancyIdJoin';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';
import { UserIdTpData } from 'src/app/common/injectable-data/user-id';

import firebase from 'firebase/compat/app';

@Injectable({
	providedIn: 'root',
})
export class FancyFirebasePlansApiBuilder {
	constructor(
		private laborCountListFactory: LaborCountListFactory,
		private ticketExceptionDaysFactory: TicketExceptionDaysListFactory,
		// BEGIN PLACEHOLDER REPLACE AS PART OF TP-6383
		private userIdTpData: UserIdTpData<string>,
		// END PLACEHOLDER REPLACE AS PART OF TP-6383
		private planListFactory: PlanListFactory,
		private planAccessListFactory: PlanAccessListFactory
	) {}

	public getPlanApi(projectId: string) {
		const planAccessListPath = fancyFirebaseGetters.getPlanAccessPath(projectId);
		const planAccessList = this.planAccessListFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(planAccessListPath, projectId)
		);
		const planAccessJoiner = new FancyIdJoin('$id', planAccessList);

		const planAccessApi = new PlanAccessApi(planAccessList, this.userIdTpData);

		const planListPath = fancyFirebaseGetters.getPlanPath(projectId);
		const planList = this.planListFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(planListPath, projectId),
			[planAccessJoiner]
		);
		const plansApi = new PlansApi(planList, planAccessApi);

		plansApi.addDestroyer(
			() => planAccessApi.destroy(),
			() => planAccessJoiner.destroy()
		);

		return plansApi;
	}

	public getLaborCountsApi(projectId: string, planId: string) {
		const crewSizePath = fancyFirebaseGetters.getCrewSizesPath(projectId, planId);
		const laborCountList = this.laborCountListFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(crewSizePath, projectId)
		);
		const laborCounts = new LaborCounts(laborCountList);

		return laborCounts;
	}

	//legacy "list/ readonly" stuff
	// eventually replace will full list versions

	public getTicketExceptionDayList(projectId: string, planId: string) {
		const ticketWorkDaysPath = fancyFirebaseGetters.getTicketWorkDaysPath(projectId, planId);
		return this.ticketExceptionDaysFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(ticketWorkDaysPath, projectId)
		);
	}
}
